import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__grid2d_cell } from '@shared/dto/grid2d_cell/DTO__grid2d_cell';
import { FN_SLICE__grid2d_recreate } from '../_methods/FN_SLICE__grid2d_recreate';
import { STATE__grid2d } from '../STATE__grid2d';

export const LOCAL__grid2d_cells_upsert = (payload: DTO__grid2d_cell[]): PayloadAction<DTO__grid2d_cell[]> => ({
  type: ENUM__redux_action.GRID2D_CELLS_UPSERT,
  payload,
});

export function INIT_LOCAL__grid2d_cells_upsert(state: STATE__grid2d, action: PayloadAction<DTO__grid2d_cell[]>) {
  let items = action.payload;

  if (items.is_empty()) return;

  let { grids2d_map } = state;

  for (let item of items) {
    if (!grids2d_map.has(item.grid2d_id)) continue; //could be null if user still doesnt this grid2d

    item = item.clone();

    let grid2d = grids2d_map.get_or_assert(item.grid2d_id);

    grid2d.cell__upsert(item);
  }

  //refresh map to trigger re-render
  FN_SLICE__grid2d_recreate(state);
}
